import * as React from "react"
import './Spinner.css'

interface Props {
  size?: 'sm' | 'md' | 'lg'
  label?: string
}

export function Spinner({ size = 'md', label }: Props): React.JSX.Element {
  return (
    <span className={`spinner spinner-${size}`} role="status" aria-live="polite">
      <span className="visually-hidden">{label ?? 'Loading'}</span>
    </span>
  )
}
